import React, { useMemo, useEffect, useState, useCallback } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { AuthingButton } from "../../../components/AuthingButton";

const isWindow = () => typeof window !== "undefined";
const isDocument = () => typeof document !== "undefined";
export const TenantAdvantage2 = () => {
  const { t } = useTranslation();
  const list = useMemo(() => {
    return [
      {
        title: t("tenant.feature.item4.title"),
        desc: t("tenant.feature.item4.descript"),
        imgUrl: "https://files.authing.co/authing-website/tenant-customer2.png",
        downText: t("common.button.linkDoc"),
        downUrl:
          "https://docs.authing.cn/v2/multi-tenant-console/multi-tenant-config.html",
      },
      {
        title: t("tenant.feature.item5.title"),
        desc: t("tenant.feature.item5.descript"),
        imgUrl: "https://files.authing.co/authing-website/tenant-own2.png",
        downText: t("common.button.linkDoc"),
        downUrl:
          "https://docs.authing.cn/v2/multi-tenant-console/admin-management.html",
      },
    ];
  }, [t]);
  const [topValue, setTopValue] = useState("0px");
  const [bottomValue, setBottomValue] = useState();
  const [scrollTop, setScrollTop] = useState(0);
  const [bannerIndex, setBannerIndex] = useState(0);
  const scrollHandler = useCallback(() => {
    if (isDocument()) {
      const chrildElement =
        isDocument() && document.querySelector(".bannerBox-right-chrild");
      const documentScrollTop =
        (isDocument() && document.body.scrollTop) ||
        document.documentElement.scrollTop;
      const selfHeight =
        isWindow() &&
        Number(window.getComputedStyle(chrildElement).height.split("px")[0]);
      if (topValue < documentScrollTop) {
        const index = Math.round((documentScrollTop - topValue) / selfHeight);
        if (index < list.length) {
          setBannerIndex(index);
        }
      }
      setScrollTop(documentScrollTop);
    }
  });
  const [element, setElement] = useState(0);
  useEffect(() => {
    scrollHandler();
  }, [scrollHandler]);
  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
  }, [scrollHandler]);
  useEffect(() => {
    if (isWindow()) {
      const bannerBox = document.getElementById("tenantAdvantageBox");
      if (bannerBox) {
        setTopValue(bannerBox.offsetTop);
        setBottomValue(
          isWindow() &&
            Number(window.getComputedStyle(bannerBox).height.split("p")[0]) +
              topValue,
          +"px"
        );
      }
    }
  }, [scrollHandler, topValue]);
  const clientHeight =
    (isDocument() && document.documentElement.clientHeight) || "";
  const cls = classNames({
    "bannerBox-left": true,
    fixed:
      scrollTop + 80 > topValue && scrollTop + clientHeight < bottomValue
        ? true
        : false,
    bottom: scrollTop + clientHeight > bottomValue ? true : false,
  });
  // 移动端需要
  const nextFun = () => {
    if (element >= list.length - 1) {
      setElement(0);
    } else {
      setElement(element + 1);
    }
  };
  const lastFun = () => {
    if (element <= 0) {
      setElement(list.length - 1);
    } else {
      setElement(element - 1);
    }
  };

  const renderScrollScreenPC = () => {
    return (
      <div className="tenant-advantage-pc">
        <div className="banner-connection" id="tenantAdvantageBox">
          <div className="bannerBox-list">
            {list.map((item, index) => {
              return (
                <div key={"bannerBox-right" + index}>
                  <div className="bannerBox-right">
                    <div className="bannerBox-right-chrild">
                      <img
                        src={item.imgUrl}
                        alt={item.alt}
                        style={{ zIndex: "2" }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className={cls}>
            <div className="info-box">
              {list.map((item, index) => {
                return (
                  <div
                    className="info-box-item"
                    key={"info-box" + index}
                    style={
                      bannerIndex === index
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <div className="info-box-item-title">{item.title}</div>
                    <div className="info-box-blue-gap"></div>
                    <div className="info-box-item-content">{item.desc}</div>
                    <AuthingButton
                      mode="small"
                      onClick={() => {
                        window.open(item.downUrl);
                      }}
                    >
                      {item.downText}
                    </AuthingButton>
                  </div>
                );
              })}
            </div>
            <div className="index-box">
              {list.map((item, index) => {
                return (
                  <li
                    className={bannerIndex === index ? "li" : ""}
                    key={item.title}
                  ></li>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderScrollScreenMobile = () => {
    return (
      <div className="manufacturing-advantage-mobile">
        <div
          className="last-button"
          onClick={() => {
            lastFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
        <div className="manufacturing-advantage-content">
          {list.map((item, index) => {
            if (element === index) {
              return (
                <>
                  <div className="value-text-title">{item.title}</div>
                  <div className="value-text-context">{item.desc}</div>
                  <div style={{ textAlign: "center" }}>
                    {/* <AuthingButton
                      mode="small"
                      onClick={() => {
                        window.open(item.downUrl);
                      }}
                    >
                      {item.downText}
                    </AuthingButton> */}
                  </div>
                  <div className="value-text-img">
                    <img src={item.imgUrl} alt={item.alt} />
                  </div>
                </>
              );
            } else {
              return null;
            }
          })}
        </div>
        <div
          className="next-button"
          onClick={() => {
            nextFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
      </div>
    );
  };
  return (
    <div className="tenant-advantage manufacturing-column">
      {renderScrollScreenPC()}
      {renderScrollScreenMobile()}
    </div>
  );
};
